var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoDataGraphic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 118.652,
    height: 115.819,
    viewBox: "0 0 118.652 115.819",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "no_data_graphic",
    transform: "translate(-0.001 -0.004)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_919",
    "data-name": "Path 919",
    d: "M383.48,182.994H351.509a2.751,2.751,0,0,0-2.748,2.748V256.8l-.366.112-7.843,2.4a1.467,1.467,0,0,1-1.83-.973l-23.33-76.205a1.466,1.466,0,0,1,.973-1.83l12.086-3.7,35.039-10.725,12.086-3.7a1.464,1.464,0,0,1,1.83.971l5.963,19.479Z",
    transform: "translate(-308.154 -156.944)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_920",
    "data-name": "Path 920",
    d: "M358.485,159.6,351.3,136.121a3.113,3.113,0,0,0-3.889-2.067l-16.993,5.2-35.037,10.727-16.993,5.2a3.117,3.117,0,0,0-2.067,3.889l24.565,80.232a3.119,3.119,0,0,0,2.979,2.2,3.076,3.076,0,0,0,.911-.137l11.648-3.565.366-.114v-.383l-.366.112-11.756,3.6a2.751,2.751,0,0,1-3.431-1.823l-24.563-80.234a2.744,2.744,0,0,1,1.823-3.431l16.993-5.2,35.037-10.725,16.993-5.2a2.745,2.745,0,0,1,3.431,1.823L358.1,159.6l.114.366h.381Z",
    transform: "translate(-276.182 -133.913)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_921",
    "data-name": "Path 921",
    d: "M380.984,168.671a1.652,1.652,0,0,1-1.578-1.166l-2.36-7.708a1.649,1.649,0,0,1,1.094-2.059l32.233-9.868a1.65,1.65,0,0,1,2.059,1.094l2.36,7.708a1.651,1.651,0,0,1-1.094,2.059L381.466,168.6A1.645,1.645,0,0,1,380.984,168.671Z",
    transform: "translate(-358.507 -145.25)",
    fill: "#eef"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_348",
    "data-name": "Ellipse 348",
    cx: 3.664,
    cy: 3.664,
    r: 3.664,
    transform: "translate(31.175 0.911)",
    fill: "#eef"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_349",
    "data-name": "Ellipse 349",
    cx: 2.32,
    cy: 2.32,
    r: 2.32,
    transform: "translate(32.518 2.255)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_922",
    "data-name": "Path 922",
    d: "M595.8,371.4H533.876a1.559,1.559,0,0,1-1.557-1.557v-74.2a1.559,1.559,0,0,1,1.557-1.557H595.8a1.559,1.559,0,0,1,1.557,1.557v74.2A1.559,1.559,0,0,1,595.8,371.4Z",
    transform: "translate(-485.391 -264.739)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_923",
    "data-name": "Path 923",
    d: "M537.5,274.087H498.933a3.119,3.119,0,0,0-3.115,3.115v74.712l.366-.112V277.2a2.751,2.751,0,0,1,2.748-2.748h38.679Zm33.619,0H498.933a3.119,3.119,0,0,0-3.115,3.115v83.909a3.119,3.119,0,0,0,3.115,3.115h72.184a3.119,3.119,0,0,0,3.115-3.115V277.2A3.119,3.119,0,0,0,571.117,274.087Zm2.748,87.024a2.751,2.751,0,0,1-2.748,2.748H498.933a2.751,2.751,0,0,1-2.748-2.748V277.2a2.751,2.751,0,0,1,2.748-2.748h72.184a2.751,2.751,0,0,1,2.748,2.748Z",
    transform: "translate(-455.578 -248.403)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_924",
    "data-name": "Path 924",
    d: "M644.177,267.446h-33.71a1.651,1.651,0,0,1-1.649-1.649v-8.061a1.651,1.651,0,0,1,1.649-1.649h33.71a1.651,1.651,0,0,1,1.649,1.649V265.8A1.651,1.651,0,0,1,644.177,267.446Z",
    transform: "translate(-547.876 -233.701)",
    fill: "#eef"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_350",
    "data-name": "Ellipse 350",
    cx: 3.664,
    cy: 3.664,
    r: 3.664,
    transform: "translate(75.783 15.607)",
    fill: "#eef"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_351",
    "data-name": "Ellipse 351",
    cx: 2.232,
    cy: 2.232,
    r: 2.232,
    transform: "translate(77.215 17.04)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDataGraphic);
export default __webpack_public_path__ + "static/media/no_data_graphic.fa13f6d0d1cd99febea79296f533a539.svg";
export { ForwardRef as ReactComponent };